// import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
Vue.prototype.alOssUrl = process.env.VUE_APP_ALOSSURL
Vue.config.productionTip = false

// api
import api from './api/index.js'
//接口
Vue.prototype.api = api

import './util/js/HttpUtil'
import './util/js/Axios'
import './util/js/util.js'

function setThemeColor(color) {
  document.documentElement.style.setProperty('--el-color-primary', color)
}

// 获取主题色并设置（示例：可替换为实际接口调用）
async function fetchAndSetThemeColor() {
  // 这里用本地模拟，实际可用 axios 调用后台接口
  // const res = await axios.get('/api/get-theme-color')
  // const color = res.data.color || '#FF3B3D'
  const color = store?.state?.themeColor || '#FF3B3D';
  setThemeColor(color)
}

fetchAndSetThemeColor()

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    fetchAndSetThemeColor()
  }
}).$mount('#app')
